export const enum ApiErrorType {
  REBOOKING_NOT_APPLICABLE = 'REBOOKING_NOT_APPLICABLE',
  REBOOKING_NOT_APPLICABLE_TO_NEW_FLOW = 'REBOOKING_NOT_APPLICABLE_TO_NEW_FLOW',
  REBOOKING_NOT_APPLICABLE_SIGNED_OUT = 'REBOOKING_NOT_APPLICABLE_SIGNED_OUT',
  MISSING_REQUIRED_FIELDS = 'MISSING_REQUIRED_FIELDS',
  OFFERS_CACHE_NOT_AVAILABLE = 'OFFERS_CACHE_NOT_AVAILABLE',
  OUTBOUND_INBOUND_TOO_CLOSE = 'OUTBOUND_INBOUND_TOO_CLOSE',
  NO_FLIGHTS_AVAILABLE_FOR_DATES = 'NO_FLIGHTS_AVAILABLE_FOR_DATES',
  NO_FARE_FOUND_FOR_REQUESTED_FARE_FAMILY = 'NO_FARE_FOUND_FOR_REQUESTED_FARE_FAMILY',
  RESERVATION_NOT_FOUND = 'RESERVATION_NOT_FOUND',
  NO_FARE_COMBINATION_AVAILABLE = 'NO_FARE_COMBINATION_AVAILABLE',
  COLLECT_AND_REFUND_REBOOKING = 'COLLECT_AND_REFUND_REBOOKING',
  FARE_NOT_AVAILABLE = 'FARE_NOT_AVAILABLE',
  FARE_NOT_SUPPORTED = 'FARE_NOT_SUPPORTED',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNKNOWN = 'UNKNOWN',
  INVALID_PASSENGER_COUNT = 'INVALID_PASSENGER_COUNT',
  INVALID_POINT_OF_SALE = 'INVALID_POINT_OF_SALE',
  INVALID_AIRPORT_CODE = 'INVALID_AIRPORT_CODE',
  INVALID_BOUND = 'INVALID_BOUND',
  INVALID_DATE = 'INVALID_DATE',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  PASSENGER_FIELD_ERRORS = 'PASSENGER_FIELD_ERRORS',
  UNSUPPORTED_DATA = 'UNSUPPORTED_DATA',
  POINTS_DEDUCTION_FAILED = 'POINTS_DEDUCTION_FAILED',
  UNABLE_TO_RETRIEVE_OFFERS = 'UNABLE_TO_RETRIEVE_OFFERS',
  SERVICE_CLASS_MISSING = 'SERVICE_CLASS_MISSING',
  ORIGIN_AND_OR_DESTINATION_NOT_SUPPORTED = 'ORIGIN_AND_OR_DESTINATION_NOT_SUPPORTED',
  REBOOKING_NOT_POSSIBLE = 'REBOOKING_NOT_POSSIBLE',
}
